<section class="flex-1 bg-white">
    <div class="max-w-[1400px] mx-auto px-6 py-16 flex flex-col lg:flex-row items-start gap-16">

        <!-- Left Column: Reset Form -->
        <div class="lg:w-1/2 w-full">
            <div class="font-fraunce text-5xl font-normal text-app-primary-20 my-12">Passwort zurücksetzen</div>

            <div class="space-y-6">
                <!-- Temporary Password -->
                <div class="flex flex-col gap-2 relative">
                    <label class="text-app-primary-20">Temporäres Passwort *</label>
                    <div class="relative">
                        <input matInput [type]="hidePasswordSec ? 'password' : 'text'" [formControl]="temporaryPasswordControl"
                               placeholder="Temporäres Passwort aus Ihrer E-Mail" class="w-full">
                        <button (click)="hidePasswordSec = !hidePasswordSec"
                                class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-app-primary-10 cursor-pointer">
                            <i class="fa-solid" [ngClass]="{'fa-eye': !hidePasswordSec, 'fa-eye-slash': hidePasswordSec}"></i>
                        </button>
                    </div>
                </div>

                <!-- New Password -->
                <div class="flex flex-col gap-2 relative">
                    <label class="text-app-primary-20">Neues Passwort *</label>
                    <div class="relative">
                        <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="newPasswordControl"
                               placeholder="Neues Passwort" class="w-full">
                        <button (click)="hidePassword = !hidePassword"
                                class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-app-primary-10 cursor-pointer">
                            <i class="fa-solid" [ngClass]="{'fa-eye': !hidePassword, 'fa-eye-slash': hidePassword}"></i>
                        </button>
                    </div>

                    @if (newPasswordControl!.dirty && newPasswordControl!.errors) {
                        <div class="flex flex-col gap-1 mt-2">
                            @if (newPasswordControl!.errors!['minLength']) {
                                <div class="text-red-500 text-xs">Mindestens 12 Zeichen</div>
                            }
                            @if (newPasswordControl!.errors!['minLowerCase']) {
                                <div class="text-red-500 text-xs">Mindestens 1 Kleinbuchstabe</div>
                            }
                            @if (newPasswordControl!.errors!['minUpperCase']) {
                                <div class="text-red-500 text-xs">Mindestens 1 Großbuchstabe</div>
                            }
                            @if (newPasswordControl!.errors!['minDigits']) {
                                <div class="text-red-500 text-xs">Mindestens 1 Ziffer</div>
                            }
                            @if (newPasswordControl!.errors!['minSpecialCharacters']) {
                                <div class="text-red-500 text-xs">Mindestens 1 Sonderzeichen</div>
                            }
                        </div>
                    }
                </div>

                <!-- Password Confirmation -->
                <div class="flex flex-col gap-2 relative">
                    <label class="text-app-primary-20">Passwort wiederholen *</label>
                    <div class="relative">
                        <input [type]="hidePasswordConfirm ? 'password' : 'text'" matInput
                               placeholder="Passwort wiederholen"
                               [formControl]="passwordConfirmControl" class="w-full">
                        <button (click)="hidePasswordConfirm = !hidePasswordConfirm"
                                class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-app-primary-10 cursor-pointer">
                            <i class="fa-solid" [ngClass]="{'fa-eye': !hidePasswordConfirm, 'fa-eye-slash': hidePasswordConfirm}"></i>
                        </button>
                    </div>
                    @if (passwordConfirmControl!.valid && newPasswordControl!.value !== passwordConfirmControl!.value) {
                        <div class="text-red-500 text-xs mt-1">* Passwörter stimmen nicht überein</div>
                    }
                </div>

                <!-- Submit Button -->
                <div class="pt-4 flex justify-end">
                    <button class="btn primary-button w-full sm:w-auto flex items-center justify-center gap-2" (click)="saveNewPassword()">
                        <span>Neues Passwort speichern</span>
                        <i class="fa-solid fa-angle-right"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Right Column: Info/Background -->
        <div class="lg:w-1/2 w-full flex flex-col gap-8">
            <div class="bg-app-background-20 rounded-2xl p-8 lg:p-12">
                <h3 class="font-fraunce text-3xl text-app-primary-20 mb-6">Sicherheitshinweis</h3>
                <p class="text-gray-600 leading-relaxed">
                    Wählen Sie ein starkes Passwort, das Sie noch nicht für andere Dienste verwendet haben.
                    Ein sicheres Passwort schützt Ihre persönlichen Gesundheitsdaten.
                </p>
                <ul class="mt-6 space-y-3 text-sm text-gray-600">
                    <li class="flex items-center gap-2">
                        <i class="fa-solid fa-check text-app-secondary-10"></i>
                        Mindestens 12 Zeichen
                    </li>
                    <li class="flex items-center gap-2">
                        <i class="fa-solid fa-check text-app-secondary-10"></i>
                        Groß- und Kleinbuchstaben
                    </li>
                    <li class="flex items-center gap-2">
                        <i class="fa-solid fa-check text-app-secondary-10"></i>
                        Zahlen und Sonderzeichen
                    </li>
                </ul>
            </div>
        </div>

    </div>
</section>
